module.exports = __webpack_public_path__ + "img/product_mb_02.30a204e.png";